import { createStyles, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React, { useState } from 'react';
import CustomStepperTrackingText from '../CustomStepperTrackingText/CustomStepperTrackingText';
import CustomStepperTrackingTooltip from '../CustomStepperTrackingTooltip/CustomStepperTrackingTooltip';
import useStyles from './CustomStepperTrackingChildStyles';
var CustomStepperTrackingChild = function (_a) {
    var _b;
    var className = _a.className, customStepperTrackingProps = _a.customStepperTrackingProps;
    var IconoStepper = customStepperTrackingProps.icono;
    var styles = useStyles();
    var _c = useState(false), isHovering = _c[0], setIsHovering = _c[1];
    var obtenerColorLinea = function (colorLinea) {
        switch (colorLinea) {
            case 'verdeClaro':
                return 'var(--verde-exito)';
            case 'verdeOscuro':
                return 'var(--verde-l33)';
            case 'rojo':
                return 'var(--rojo-error)';
            case 'amarillo':
                return 'var(--amarillo-l44)';
            case 'grisL93':
                return 'var(--gris-l93)';
            case 'grisL83':
                return 'var(--gris-l83)';
            case 'grisL63':
                return 'var(--gris-l63)';
            case 'grisL43':
                return 'var(--gris-l43)';
            default:
                return 'var(--gris-l93)';
        }
    };
    var customUseStyles = makeStyles(function () {
        return createStyles({
            small: {
                '&::before': {
                    background: "linear-gradient(to left, var(--gris-l93) 80%, " + obtenerColorLinea(customStepperTrackingProps.colorLinea) + " 10%)",
                },
            },
            medium: {
                '&::before': {
                    background: "linear-gradient(to left, var(--gris-l93) 50%, " + obtenerColorLinea(customStepperTrackingProps.colorLinea) + " 50%)",
                },
            },
            large: {
                '&::before': {
                    background: "linear-gradient(to left, var(--gris-l93) 10%, " + obtenerColorLinea(customStepperTrackingProps.colorLinea) + " 0%)",
                },
            },
            full: {
                '&::before': {
                    background: "linear-gradient(to left, var(--gris-l93) 0%, " + obtenerColorLinea(customStepperTrackingProps.colorLinea) + " 0%)",
                },
            },
            default: {
                '&::before': {
                    background: "linear-gradient(to left, var(--gris-l93) 10%, var(--gris-l93) 0%)",
                },
            },
        });
    });
    var customStyles = customUseStyles();
    var obtenerLinea = function (tamanio) {
        switch (tamanio) {
            case 'small':
                return customStyles.small;
            case 'medium':
                return customStyles.medium;
            case 'large':
                return customStyles.large;
            case 'full':
                return customStyles.full;
            default:
                return customStyles.default;
        }
    };
    var handleMouseOver = function () {
        if (customStepperTrackingProps.mostrarTooltip) {
            setIsHovering(true);
        }
    };
    var handleMouseOut = function () {
        if (customStepperTrackingProps.mostrarTooltip) {
            setIsHovering(false);
        }
    };
    return (React.createElement("div", { className: className + " " + obtenerLinea(customStepperTrackingProps.tamanioLinea) },
        React.createElement("div", { className: clsx(styles.iconoCnt, (_b = {},
                _b[styles.iconoCntPointer] = customStepperTrackingProps.mostrarTooltip,
                _b)), onMouseOver: handleMouseOver, onMouseOut: handleMouseOut },
            React.createElement(IconoStepper, { className: styles.icono })),
        React.createElement(CustomStepperTrackingText, { modeloStep: customStepperTrackingProps }),
        customStepperTrackingProps.mostrarTooltip === true ? (React.createElement(CustomStepperTrackingTooltip, { className: isHovering ? styles.tooltopVisible : styles.tooltip, modeloStep: customStepperTrackingProps })) : null));
};
export default CustomStepperTrackingChild;
